import "./VimeoPlayer.scss";

interface VimeoPlayerProps {
  videoId: number;
  hValue: string; // Parameter that Vimeo seems to require...not sure what it does
  title: string;
}

const VimeoPlayer: React.FC<VimeoPlayerProps> = ({videoId, title, hValue}) => {
  return (
    <>
      <div className="VimeoPlayer">
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?h=${hValue}&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%"}}
          title={title}
          data-ready="true"
        ></iframe>
      </div>{" "}
    </>
  );
};

export default VimeoPlayer;
